import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { subDays, differenceInCalendarDays, format } from 'date-fns';
import { _HttpClient } from '@delon/theme';
import { DialogService } from 'icc-common-lib';
import { URLS } from '../../../../shared/constant/interface';
import { formatNumber } from '../../../../shared/utils/common';

@Component({
  selector: 'app-video-statistics',
  templateUrl: './video-statistics.component.html',
  styleUrls: ['./video-statistics.component.less'],
})
export class VideoStatisticsComponent implements OnInit {
  constructor(private datePipe: DatePipe, private dialogService: DialogService, private http: _HttpClient) {
    // this.itemList = mockVideoItemListData;
  }

static NAME = 'icc-msg-social-video-statistics';

  // 时间选择器选择时间有误
  isRangeError: boolean;
  validateRange = {
    errorKey: '',
    errorList: [
      {
        key: 'max-range-error',
        value: '最大跨度为31天',
      },
      {
        key: 'min-range-error',
        value: '最小跨度为7天',
      },
    ],
  };

  @Input() channelId: number;

  searchOptions = {
    start: subDays(new Date(), 7),
    end: subDays(new Date(), 1),
  };

  postParams = {
    /* channelId: this.channelId, */
    channelId: 0,
    start: format(subDays(new Date(), 7), 'yyyyMMdd'),
    end: format(subDays(new Date(), 1), 'yyyyMMdd'),
  };

  // 加载条数
  loadCounts = 5;
  // 没有更多
  noMore = false;
  // 排序方式列表
  sortTypeList = [
    { name: '按时间', isSelected: true, isAsc: true },
    { name: '播放榜', isSelected: false, isAsc: false },
    { name: '点赞榜', isSelected: false, isAsc: false },
    { name: '评论榜', isSelected: false, isAsc: false },
    { name: '分享榜', isSelected: false, isAsc: false },
  ];
  // 默认排序方式
  sortType = '按时间';
  sortOption = 'releaseTime';
  // sortType = '播放榜';
  // sortOption = 'broadcastTotal';

  // 原数据
  @Input() itemList: any;

  // 展示数据
  displayItemList: {
    imageUrl: string; // 封面地址
    videoUrl: string; // 视频地址
    title: string; // 视频标题
    releaseTime: string; // 发布时间
    playCount: number; // 播放量
    likeCount: number; // 点赞量
    commentCount: number; // 评论量
    sharedCount: number; // 分享量
  }[] = [];

  // 格式化数据
  formatData() {
    this.displayItemList = [];
    if (this.itemList && this.itemList.length > 0) {
      for (let i = 0; i < Math.min(this.itemList.length, this.loadCounts); i++) {
        const temp: any = {};
        temp.imageUrl = this.itemList[i].coverUrl;
        temp.videoUrl = this.itemList[i].playUrl;
        temp.title = this.itemList[i].videoTitle;
        temp.releaseTime = this.datePipe.transform(this.itemList[i].releaseTime * 1000, 'yyyy-MM-dd HH:mm:ss');
        temp.playCount = this.itemList[i].broadcastTotal === null ? 0 : formatNumber(this.itemList[i].broadcastTotal);
        temp.likeCount = this.itemList[i].praiseTotal === null ? 0 : formatNumber(this.itemList[i].praiseTotal);
        temp.commentCount = this.itemList[i].commentTotal === null ? 0 : formatNumber(this.itemList[i].commentTotal);
        temp.sharedCount = this.itemList[i].sharedTotal === null ? 0 : formatNumber(this.itemList[i].sharedTotal);
        this.displayItemList.push(temp);
      }
    }
  }

  // 加载更多
  loadMore() {
    this.displayItemList = [];
    if (this.loadCounts < 20) {
      this.loadCounts = this.loadCounts + 5;
      this.formatData();
    }
    if (this.loadCounts > this.itemList.length || this.loadCounts >= 20) {
      this.noMore = true;
      if (this.loadCounts >= 20) {
        this.dialogService.notification.warning('提示', '最多加载20条视频信息');
      }
    }
  }

  // 排序
  sortByOption(e) {
    this.sortType = e.target.innerText;
    // 升降序排列标志位
    let flag = true;
    for (const item of this.sortTypeList) {
      if (item.name === this.sortType) {
        item.isSelected = true;
        item.isAsc = !item.isAsc;
        flag = item.isAsc;
      } else {
        item.isSelected = false;
      }
    }
    switch (this.sortType) {
      case '按时间':
        this.sortOption = 'releaseTime';
        break;
      case '播放榜':
        this.sortOption = 'broadcastTotal';
        break;
      case '点赞榜':
        this.sortOption = 'praiseTotal';
        break;
      case '评论榜':
        this.sortOption = 'commentTotal';
        break;
      case '分享榜':
        this.sortOption = 'sharedTotal';
        break;
      default:
        this.sortOption = 'broadcastTotal';
    }
    const option = this.sortOption;
    if (this.itemList && this.itemList.length > 0) {
      if (flag) {
        this.itemList = this.itemList.sort((a, b) => b[option] - a[option]);
      } else {
        this.itemList = this.itemList.sort((a, b) => a[option] - b[option]);
      }
    }
    this.formatData();
  }

  ngOnInit() {
    this.postParams.channelId = this.channelId;
    this.http.post(URLS.fetchTikTokVideoStatisticData.url, this.postParams).subscribe(res => {
      if (res.status === 0 && res.data && res.data.length) {
        this.itemList = res.data;
        // 初始化时，先让数据按照播放量进行排序
        this.itemList = this.itemList.sort((a, b) => b[this.sortOption] - a[this.sortOption]);
        this.formatData();
      }
    });
  }

  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, new Date()) > -1 || differenceInCalendarDays(current, new Date()) < -730;
  };

  selectDate() {
    const selectRange = differenceInCalendarDays(this.searchOptions.end, this.searchOptions.start);
    let errorKey = selectRange > 30 ? 'max-range-error' : selectRange < 6 ? 'min-range-error' : '';
    if (errorKey) {
      const filterErrors = this.validateRange.errorList.filter(item => item.key === errorKey);
      if (filterErrors.length) {
        this.dialogService.notification.error('查询条件', filterErrors[0].value);
        this.validateRange.errorKey = filterErrors[0].key;
        this.isRangeError = true;
      }
      return false;
    } else {
      this.isRangeError = false;
      this.validateRange.errorKey = '';
    }
    return true;
  }

  /* 查询时间变更更新数据 */
  handleDateChange() {
    if (this.selectDate()) {
      this.postParams.start = format(this.searchOptions.start, 'yyyyMMdd');
      this.postParams.end = format(this.searchOptions.end, 'yyyyMMdd');
      this.http.post(URLS.fetchTikTokVideoStatisticData.url, this.postParams).subscribe(res => {
        if (res.status === 0 && res.data && res.data.length) {
          this.itemList = res.data;
          this.itemList = this.itemList.sort((a, b) => b[this.sortOption] - a[this.sortOption]);
          this.formatData();
        }
      });
    } else {
      this.displayItemList = null;
    }
  }
}
